import { useState } from "react";
import { BookMarked, Search } from "lucide-react";
import Seo from "@/components/Seo";
import { GLOSSARY } from "@/data/static";

const PTA_LINK_TERMS = new Set(["PTA Approved", "IMEI", "DIRBS", "Non-PTA (Non-Approved)"]);

export default function Glossary() {
  const [q, setQ] = useState("");
  const list = GLOSSARY.filter((g) => g.term.toLowerCase().includes(q.toLowerCase()) || g.def.toLowerCase().includes(q.toLowerCase()));

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "DefinedTermSet",
    name: "Gamer's Glossary",
    hasDefinedTerm: GLOSSARY.map((g) => ({ "@type": "DefinedTerm", name: g.term, description: g.def })),
  };

  return (
    <>
      <Seo title="Gamer's Glossary - Mobile Gaming Terms" description="Understand mobile gaming phone terms: touch sampling rate, vapor chamber cooling, throttling, Adreno GPU, gyro delay, CPID, PTA and more." path="/glossary" jsonLd={jsonLd} />

      <div className="border-b border-border bg-graphite">
        <div className="mx-auto max-w-7xl px-4 py-10 sm:px-6 lg:px-8">
          <span className="inline-flex items-center gap-2 rounded-full border border-cyber/30 bg-cyber/10 px-3 py-1 text-xs font-heading font-semibold text-cyber"><BookMarked className="h-3.5 w-3.5" /> Reference</span>
          <h1 className="mt-4 font-display text-2xl font-black tracking-tight text-white sm:text-4xl">Gamer's Glossary</h1>
          <p className="mt-2 max-w-2xl text-sm text-slate-300 sm:text-base">Know the terms before you buy a gaming phone in Pakistan.</p>
          <div className="mt-5 max-w-md">
            <div className="flex items-center gap-2 rounded-lg border border-border bg-slateSurface px-3 py-2.5 focus-within:border-cyber/50">
              <Search className="h-4 w-4 text-slate-500" />
              <input data-testid="glossary-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search terms…" className="w-full bg-transparent text-sm text-white placeholder:text-slate-500 focus:outline-none" />
            </div>
          </div>
        </div>
      </div>

      <div className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((g) => (
            <div key={g.term} data-testid={`glossary-${g.term.replace(/\s+/g, "-").toLowerCase()}`} className="rounded-xl border border-border bg-slateSurface p-5 transition-all hover:border-neon/40">
              <h2 className="font-heading text-sm font-bold text-neon">{g.term}</h2>
              <p className="mt-2 text-sm leading-relaxed text-slate-300">{g.def}</p>
              {PTA_LINK_TERMS.has(g.term) && (
                <a
                  href="https://phoneflip.pk/pta-calculator"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  data-testid={`glossary-pta-link-${g.term.replace(/\s+/g, "-").toLowerCase()}`}
                  className="mt-2 inline-block text-xs font-medium text-cyber hover:underline"
                >
                  Calculate PTA tax on PhoneFlip →
                </a>
              )}
            </div>
          ))}
        </div>
        {list.length === 0 && <p className="mt-8 text-center text-slate-500">No terms match “{q}”.</p>}
      </div>
    </>
  );
}
